import AccordionDropdown from './accordion-dropdown';

export default AccordionDropdown;